import OtpForm from './OtpForm';

export default OtpForm;
